const STORAGE_KEY = 'openSurveyClientToken';

let fallbackToken: string | undefined;

/** Stable per browser so the API can throttle repeat submissions of identical answers; falls back to a per-load token when storage is blocked. */
function getOpenSurveysClientToken(): string {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored) return stored;
    const created = crypto.randomUUID();
    window.localStorage.setItem(STORAGE_KEY, created);
    return created;
  } catch {
    fallbackToken ??= crypto.randomUUID();
    return fallbackToken;
  }
}

export { getOpenSurveysClientToken };
